export default __webpack_public_path__ + "static/media/burnButton.a0849e0f.png";